<template>
    <svg :class="svgClass" aria-hidden="true" :style="{ width: size + 'px', height: size + 'px' }">
        <!-- 引用雪碧图中的对应 icon id -->
        <use :xlink:href="`/image/icons.svg#${iconName}`" :fill="color"></use>
    </svg>
</template>

<script>
    export default {
        name: 'SvgIcon',
        props: {
            // 图标名称（对应雪碧图中的 symbol id）
            iconName: {
                type: String,
                required: true
            },
            // 图标大小
            size: {
                type: [Number, String],
                default: 20
            },
            // 图标颜色
            color: {
                type: String,
                default: '#666'
            },
            // 自定义类名
            className: {
                type: String,
                default: ''
            }
        },
        computed: {
            svgClass() {
                return this.className ? `svg-icon ${this.className}` : 'svg-icon'
            }
        }
    }
</script>

<style scoped>
    .svg-icon {
        vertical-align: middle;
        /* 可根据需求补充样式 */
    }
</style>
